import React from 'react'
import './App.css'
import Header from './components/Header'
import LandingPage from './components/LandingPage';



function App() {
  return (
    <div>
    <Header />
    <LandingPage />


    </div>

  );
}

export default App;
